// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1310":"82081991","9497":"82081991"}[chunkId] + ".chunk.css";
};